import React from 'react';
import { Card, Space, Button } from 'antd';
import type { CoinRecommendation } from '../types';

interface Props {
  plans: CoinRecommendation[];
  onSelect(symbol: string): void;
}

const HotCoinsBanner: React.FC<Props> = ({ plans, onSelect }) => (
  <Space size="middle" wrap>
    {plans.map(coin => (
      <Card
        key={coin.symbol}
        hoverable
        style={{ width: 120, textAlign: 'center' }}
        onClick={() => {
          const s = coin.symbol.trim().toUpperCase();
          const sym = s.endsWith('USDT') ? s : `${s}USDT`;
          onSelect(sym);
        }}
      >
        <div style={{ fontSize: 24, fontWeight: 'bold' }}>
          {coin.symbol.trim().toUpperCase()}
        </div>
        <div style={{ marginTop: 8 }}>
          信心：{(coin.confidence * 100).toFixed(0)}%
        </div>
        <Button
          type="link"
          onClick={e => {
            e.stopPropagation();
            const s = coin.symbol.trim().toUpperCase();
            const sym = s.endsWith('USDT') ? s : `${s}USDT`;
            onSelect(sym);
          }}
          style={{ padding: 0, marginTop: 8 }}
        >
          查看
        </Button>
      </Card>
    ))}
  </Space>
);

export default HotCoinsBanner;
